<template>
  <Observer class="login-box">
    <div class="login-info">
      <div
        class="userImg"
        @click="
          reportClick('user_info', 'header')
          $util.clickStat(`GWSY/WDYX/GRZL`, `官网首页/我的游戏/个人资料`)
        "
      >
        <img :src="userInfo.avatar" @click="$router.push('/personal')" />
      </div>
      <div class="login-title">
        <em class="ellipsis-1" @click="reportClick('user_info', 'nickname')">{{
          userInfo.nickname
        }}</em>
        <VipIcon @click="reportClick('user_info', 'vip_icon')" />
        <Logout />
      </div>
      <div class="login-acc">
        <em>游戏账号: </em>
        <span>{{ userInfo.account }}</span>
      </div>
    </div>
    <div v-if="recentlyPlayed.length" class="login-item">
      <p class="login-item-tit">最近玩过</p>
      <div class="login-item-msg">
        <template v-for="item in recentlyPlayed">
          <div
            v-for="game in item.latest_server_list || []"
            :key="game.server_id"
            class="login-item-msg-link"
          >
            <a
              :href="`/game-offical/${item.game_id}`"
              target="_blank"
              class="ellipsis-1"
              @click="clickStat($event, 'YXGW', '游戏官网')"
            >
              {{ item.title }}
            </a>
            <em class="ellipsis-1">{{ game.title }}</em>
            <a
              href="javascript:;"
              @click="
                reportClick('play_recent', ``, game)
                gameStat($event, game, 'JRYX', '进入游戏')
              "
              >进入游戏&gt;&gt;</a
            >
          </div>
        </template>
      </div>
    </div>
    <div v-else-if="homeRec.length" class="login-item">
      <p class="login-item-tit">猜你喜欢</p>
      <div class="login-item-msg">
        <template v-for="item in homeRec">
          <div
            v-for="game in item.server_list || []"
            :key="game.server_id"
            class="login-item-msg-link"
          >
            <a
              :href="`/game-offical/${item.game_id}`"
              target="_blank"
              class="ellipsis-1"
              @click="clickStat($event, 'YXGW', '游戏官网')"
            >
              {{ item.title }}
            </a>
            <em class="ellipsis-1">{{ game.title }}</em>
            <a
              href="javascript:;"
              @click="
                reportClick('guess', ``, game)
                gameStat($event, game, 'JRYX', '进入游戏')
              "
              >进入游戏&gt;&gt;</a
            >
          </div>
        </template>
      </div>
    </div>
  </Observer>
</template>
<script>
import VipIcon from '~/components/logic-common/VipIcon'
import Logout from '~/components/logic-common/Logout'
export default {
  components: {
    VipIcon,
    Logout
  },
  data() {
    return {
      homeRec: []
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    recentlyPlayed() {
      return this.$store.state.user.recentlyPlayed
    }
  },
  created() {
    if (process.client) {
      Promise.all([
        this.$util.allResolve(this.$store.dispatch('user/getRecentlyPlayed')),
        this.$util.allResolve(this.getRec())
      ]).then(() => {
        this.userInfo.sessionid && this.reportShow()
      })
    }
  },
  methods: {
    gameStat(e, game, eid, eid_desc) {
      const target = e.currentTarget.parentNode
      const nodeList = e.currentTarget.parentNode.parentNode.children
      const { game_id, server_id = 0 } = game
      for (let i = 0; i < nodeList.length; i++) {
        if (target === nodeList[i]) {
          this.$util.gameStat(
            game_id,
            server_id,
            `GWSY/WDYX/${eid}${i + 1}`,
            `官网首页/我的游戏/${eid_desc}${i + 1}`
          )
        }
      }
    },
    clickStat(e, eid, eid_desc) {
      const target = e.currentTarget.parentNode
      const nodeList = e.currentTarget.parentNode.parentNode.children
      for (let i = 0; i < nodeList.length; i++) {
        if (target === nodeList[i]) {
          this.$util.clickStat(
            `GWSY/WDYX/${eid}${i + 1}`,
            `官网首页/我的游戏/${eid_desc}${i + 1}`
          )
        }
      }
    },
    reportClick(click_area, click_id, game) {
      this.$xlaPush('home_page_user_card_click', {
        click_area,
        click_id,
        ...(game
          ? {
              game_id: game.game_id,
              game_name: game.title,
              channel: game.server_id || 'none'
            }
          : {})
      })
    },
    reportShow() {
      this.$xlaPush('home_page_user_card_show', {
        recent_list:
          this.recentlyPlayed
            .map(
              (e) =>
                `game_id=${e.game_id},game_name=${e.title},channel=${e.server_id};`
            )
            .join('') || 'none',
        guess_list:
          this.homeRec
            .map(
              (e) =>
                `game_id=${e.game_id},game_name=${e.title},channel=${e.server_id};`
            )
            .join() || 'none'
      })
    },
    getRec() {
      return this.$request('homeRec').then((data = []) => {
        return (this.homeRec = data)
      })
    }
  }
}
</script>
